import { baseApi } from "../baseApi";

export const itemApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDoctypeDetails: builder.query({
      query: (params) => ({
        url: `/api/method/frappe.client.get`,
        params: params,
      }),
      keepUnusedDataFor: 0,
      providesTags: [],
    }),
    postItemOrder: builder.mutation({
      query: ({ start = 0, limit = 12, filters = [], fields = [] }) => ({
        url: `/api/resource/Item`,
        method: "GET",
        params: {
          filters: JSON.stringify(filters),
          fields: JSON.stringify(
            fields.length > 0
              ? fields
              : [
                "item_name",
                "item_group",
                "disabled",
                "item_code",
                "naming_series",
                "name",
                "end_of_life",
              ]
          ),
          order_by: "`tabItem`.`modified` desc",
          limit_start: start,
          limit_page_length: limit,
        },
      }),

    }),
    totalItem: builder.mutation({
      query: () => ({
        url: `/api/method/frappe.client.get_count?doctype=Item`,
        method: "GET",
      }),
    }),
    itemGroup: builder.mutation({
      query: () => ({
        url: `/api/resource/Item%20Group`,
        method: "GET",
      }),
    }),
    itemCompany: builder.mutation({
      query: () => ({
        url: `/api/resource/Company`,
        method: "GET",
      }),
    }),
    itemBrand: builder.mutation({
      query: () => ({
        url: `/api/resource/Brand`,
        method: "GET",
        params: {


          limit_start: 0,
          limit_page_length: 2500,
          order_by: "`tabBrand`.`modified` desc",
        },
      }),
    }),
    itemUOM: builder.mutation({
      query: () => ({
        url: `/api/resource/UOM`,
        method: "GET",
        params: {
          limit_start: 0,
          limit_page_length: 2500,
          order_by: "`tabUOM`.`modified` desc",
        },
      }),
    }),
    getUOMSearch: builder.mutation({
      query: (data) => ({
        url: "/api/resource/UOM",
        method: "GET",
        params: {
          filters: JSON.stringify([["UOM", "name", "like", `%${data.search_input}%`]]),
          limit_start: data.start,
          limit_page_length: 2000,
          order_by: "`tabUOM`.`modified` desc"
        }
      })
    }),
    itemGSTHSNCode: builder.mutation({
      query: () => ({
        url: `/api/resource/GST%20HSN%20Code`,
        method: "GET",
        params: {
          limit_start: 0,
          limit_page_length: 25000,
          order_by: "`tabGST HSN Code`.`modified` desc",
        },
      }),
    }),
    itemTaxTemplate: builder.mutation({
      query: () => ({
        url: `/api/resource/Item%20Tax%20Template`,
        method: "GET",
      }),
    }),
    itemTaxCategory: builder.mutation({
      query: () => ({
        url: `/api/resource/Tax%20Category`,
        method: "GET",
      }),
    }),

    itemQualityInspectionTemplate: builder.mutation({
      query: () => ({
        url: `/api/resource/Quality%20Inspection%20Template`,
        method: "GET",
      }),
    }),

    itemWarehouseCheckInList: builder.mutation({
      query: ({ offset = 0, limit = 20 } = {}) => {
        const fields = encodeURIComponent(
          JSON.stringify([
            "name",
            "warehouse_type",
            "company",
            "creation",
            "disabled",
          ])
        );
        const filters = encodeURIComponent(
          JSON.stringify([["is_group", "=", 1]])
        );

        return {
          url: `/api/resource/Warehouse?fields=${fields}&filters=${filters}&limit_start=${offset}&limit_page_length=${limit}`,
          method: "GET",
        };
      },
    }),

    itemWarehouseRequestList: builder.mutation({
      query: ({ offset = 0, limit = 20 } = {}) => {
        const fields = encodeURIComponent(
          JSON.stringify([
            "name",
            "warehouse_type",
            "company",
            "creation",
            "disabled",
          ])
        );
        const filters = encodeURIComponent(
          JSON.stringify([["is_group", "=", 1]])
        );

        return {
          url: `/api/resource/Warehouse?fields=${fields}&filters=${filters}&limit_start=${offset}&limit_page_length=${limit}`,
          method: "GET",
        };
      },
    }),

    itemSupplier: builder.mutation({
      query: () => ({
        url: `/api/resource/Supplier`,
        method: "GET",

      }),
    }),
    itemSupplierSearchByName: builder.mutation({
      query: ({ start = 0, search_input = "" }) => ({
        url: "/api/resource/Supplier",
        method: "GET",
        params: {
          filters: JSON.stringify([["name", "like", `%${search_input}%`]]),
          start: start,
          limit_page_length:2000
        }
      }),
    }),
    countryList: builder.mutation({
      query: () => ({
        url: `/api/resource/Country`,
        method: "GET",
        params: {
          limit_page_length:1200
        }
      }),
    }),

    customsTariffNumber: builder.mutation({
      query: () => ({
        url: `/api/resource/Customs%20Tariff%20Number`,
        method: "GET",
      }),
    }),
    customerDetails: builder.mutation({
  query: ({ start = 0, search_input = "" }) => ({
    url: `/api/resource/Customer`,
    method: "GET",
    params: {
      filters: JSON.stringify([["name", "like", `%${search_input}%`]]),
      start: start,
      limit_page_length: 2000
    }
  }),
}),

    customerGroupDetails: builder.mutation({
      query: ({start =0,search_input=""}) => ({
        url: `/api/resource/Customer%20Group`,
        method: "GET",
        params: {
          filters: JSON.stringify([["name", "like", `%${search_input}%`]]),
          start: start,
          limit_page_length:2000
        }
      }),
    }),

    postCreateItem: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Item`,
        method: "post",
        body: data,
      }),
    }),
    postUpdateItem: builder.mutation({
      query: ({ name, ...payload }) => ({
        url: `/api/resource/Item/${name}`,
        method: "PUT",
        body: payload,
      }),
    }),
    // Start API for item group master

    // postItemGroupOrder: builder.mutation({
    //   query: ({ start = 0, limit = 12 }) => ({
    //     url: `/api/resource/Item Group`,
    //     method: "GET",
    //     params: {
    //       fields: JSON.stringify([
    //         "name",
    //         "item_group_name",
    //         "parent_item_group",
    //         "is_group",
    //       ]),
    //       order_by: '`tabItem Group`.`modified` desc',
    //       limit_start: start,
    //       limit_page_length: limit,
    //     },
    //   }),
    // }),

    postItemGroupOrder: builder.mutation({
      query: ({ start = 0, limit = 12, filters = [], fields = [] }) => ({
        url: `/api/resource/Item Group`,
        method: "GET",
        params: {
          filters: JSON.stringify(filters), // ✅ stringified filters array
          fields: JSON.stringify(
            fields.length > 0
              ? fields
              : [
                "name",
                "item_group_name",
                "parent_item_group",
                "is_group",
              ]
          ), // ✅ use default if not passed
          order_by: "`tabItem Group`.`modified` desc",
          limit_start: start,
          limit_page_length: limit,
        },
      }),
    }),



    totalItemGroup: builder.mutation({
      query: () => ({
        url: `/api/method/frappe.client.get_count?doctype=Item Group`,
        method: "GET",
      }),
    }),
    priceDetailsList: builder.mutation({
      query: () => ({
        url: `/api/resource/Price List`,
        method: "GET",
      }),
    }),

    postCreateItemGroup: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Item Group`,
        method: "post",
        body: data,
      }),
    }),
    postUpdateItemGroup: builder.mutation({
      query: ({ name, ...payload }) => ({
        url: `/api/resource/Item Group/${name}`,
        method: "PUT",
        body: payload,
      }),
    }),
    // End API for item group master
    // start uom master api
    postUOMOrder: builder.mutation({
      query: ({ start = 0, limit = 12, filters = [], fields = [] }) => ({
        url: `/api/resource/UOM`,
        method: "GET",
        params: {
          filters: JSON.stringify(filters), // ✅ stringified filters array
          fields: JSON.stringify(
            fields.length > 0
              ? fields
              : [
                "enabled",
                "uom_name",
                "must_be_whole_number",
              ]
          ), // ✅ use default if not passed
          order_by: "`tabUOM`.`modified` desc",
          limit_start: start,
          limit_page_length: limit,
        },
      }),
      // query: ({ start = 0, limit = 12 }) => ({
      //   url: `/api/resource/UOM`,
      //   method: "GET",
      //   params: {
      //     fields: JSON.stringify([
      //       "enabled",
      //       "uom_name",
      //       "must_be_whole_number",
      //     ]),
      //     order_by: '`tabUOM`.`modified` desc',
      //     limit_start: start,
      //     limit_page_length: limit,
      //   },
      // }),
    }),
    totalUOM: builder.mutation({
      query: () => ({
        url: `/api/method/frappe.client.get_count?doctype=UOM`,
        method: "GET",
      }),
    }),

    postCreateUOM: builder.mutation({
      query: (data) => ({
        url: `/api/resource/UOM`,
        method: "post",
        body: data,
      }),
    }),

    postUpdateUOM: builder.mutation({
      query: ({ unitName, ...payload }) => ({
        url: `/api/resource/UOM/${unitName}`,
        method: "PUT",
        body: payload,
      }),
    }),

    // Start API for uom master

    // Start API for item attribute master

    postItemAttributeOrder: builder.mutation({

      query: ({ start = 0, limit = 12, filters = [], fields = [] }) => ({
        url: `/api/resource/Item Attribute`,
        method: "GET",
        params: {
          filters: JSON.stringify(filters), // ✅ stringified filters array
          fields: JSON.stringify(
            fields.length > 0
              ? fields
              : [
                "attribute_name"
              ]
          ), // ✅ use default if not passed
          order_by: "`tabItem Attribute`.`modified` desc",
          limit_start: start,
          limit_page_length: limit,
        },
      }),
      // query: ({ start = 0, limit = 12 }) => ({
      //   url: `/api/resource/Item Attribute`,
      //   method: "GET",
      //   params: {
      //     fields: JSON.stringify(["attribute_name"]),
      //     order_by: '`tabItem Attribute`.`modified` desc',
      //     limit_start: start,
      //     limit_page_length: limit,
      //   },
      // }),
    }),
    totalItemAttribute: builder.mutation({
      query: () => ({
        url: `/api/method/frappe.client.get_count?doctype=Item Attribute`,
        method: "GET",
      }),
    }),

    postCreateItemAttribute: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Item Attribute`,
        method: "post",
        body: data,
      }),
    }),
    postUpdateItemAttribute: builder.mutation({
      query: ({ attribute_name, ...payload }) => ({
        url: `/api/resource/Item Attribute/${attribute_name}`,
        method: "PUT",
        body: payload,
      }),
    }),
    // Start API for item attribute master

    // Start API for item price master

    postItemPriceOrder: builder.mutation({

      query: ({ start = 0, limit = 12, filters = [], fields = [] }) => ({
        url: `/api/resource/Item Price`,
        method: "GET",
        params: {
          filters: JSON.stringify(filters), // ✅ stringified filters array
          fields: JSON.stringify(
            fields.length > 0
              ? fields
              : [
                "item_name",
                "item_code",
                "price_list",
                "price_list_rate",
                "name",
              ]
          ), // ✅ use default if not passed
          order_by: "`tabItem Price`.`modified` desc",
          limit_start: start,
          limit_page_length: limit,
        },
      }),
      // query: ({ start = 0, limit = 12 }) => ({
      //   url: `/api/resource/Item Price`,
      //   method: "GET",
      //   params: {
      //     fields: JSON.stringify([
      //       "item_name",
      //       "item_code",
      //       "price_list",
      //       "price_list_rate",
      //       "name",
      //     ]),
      //     order_by: '`tabItem Price`.`modified` desc',
      //     limit_start: start,
      //     limit_page_length: limit,
      //   },
      // }),
    }),
    totalItemPrice: builder.mutation({
      query: () => ({
        url: `/api/method/frappe.client.get_count?doctype=Item Price`,
        method: "GET",
      }),
    }),

    postCreateItemPrice: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Item Price`,
        method: "post",
        body: data,
      }),
    }),
    postUpdateItemPrice: builder.mutation({
      query: ({ name, ...payload }) => ({
        url: `/api/resource/Item Price/${name}`,
        method: "PUT",
        body: payload,
      }),
    }),
    totalItemList: builder.mutation({
      query: () => ({
        url: `/api/resource/Item`,
        method: "GET",
        params: {
          limit_start: 0,
          limit_page_length: 2500,
          order_by: "`tabItem`.`modified` desc",
        },
      }),
    }),

    totalBatchNoList: builder.mutation({
      query: () => ({
        url: `/api/resource/Batch`,
        method: "GET",
      }),
    }),

    getItemDetails: builder.mutation({
      query: (itemCode) => ({
        url: `/api/resource/Item/${encodeURIComponent(itemCode)}`, // Encode for spaces/special chars
        method: "GET",
      }),
    }),
    // Start API for item price master

    // Start API for supplier master

    postSupplierList: builder.mutation({

      query: ({ start = 0, limit = 12, filters = [], fields = [] }) => ({
        url: `/api/resource/Supplier`,
        method: "GET",
        params: {
          filters: JSON.stringify(filters), // ✅ stringified filters array
          fields: JSON.stringify(
            fields.length > 0
              ? fields
              : [
                "supplier_name",
                "supplier_group",
                "release_date",
                "country",
                "disabled",
              ]
          ),
          order_by: "`tabSupplier`.`modified` desc",
          limit_start: start,
          limit_page_length: limit,
        },
      }),
      // query: ({ start = 0, limit = 12 }) => ({
      //   url: `/api/resource/Supplier`,
      //   method: "GET",
      //   params: {
      //     fields: JSON.stringify([
      //       "supplier_name",
      //       "supplier_group",
      //       "release_date",
      //       "country",
      //       "disabled",
      //     ]),
      //     order_by: '`tabSupplier`.`modified` desc',
      //     limit_start: start,
      //     limit_page_length: limit,
      //   },
      // }),
    }),
    totalSupplierCount: builder.mutation({
      query: () => ({
        url: `/api/method/frappe.client.get_count?doctype=Supplier`,
        method: "GET",
      }),
    }),

    postCreateSupplier: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Supplier`,
        method: "post",
        body: data,
      }),
    }),
    postUpdateSupplier: builder.mutation({
      query: ({ supplier_name, ...payload }) => ({
        url: `/api/resource/Supplier/${supplier_name}`,
        method: "PUT",
        body: payload,
      }),
    }),
    totalSupplierGroupList: builder.mutation({
      query: () => ({
        url: `/api/resource/Supplier Group`,
        method: "GET",
        params: {
          limit_start: 0,
          limit_page_length: 2500,
          order_by: "`tabSupplier Group`.`modified` desc",
        },
      }),
    }),


    totalTerritoryList: builder.mutation({
      query: () => ({
        url: `/api/resource/Territory`,
        method: "GET",
      }),
    }),

    // totalCurrencyList: builder.mutation({
    //   query: () => ({
    //     url: `/api/resource/Currency`,
    //     method: "GET",
    //   }),
    // }),
    totalCurrencyList: builder.mutation({
      query: () => ({
        url: `/api/resource/Currency?filters=${encodeURIComponent(
          JSON.stringify({ enabled: 1 })
        )}`,
        method: "GET",
      }),
    }),

    totalBankAccountList: builder.mutation({
      query: () => ({
        // url: `/api/resource/Bank Account`,
        url: `/api/resource/Bank Account?filters=${encodeURIComponent(
          JSON.stringify({ is_company_account: 1 })
        )}`,
        method: "GET",
      }),
    }),
    totalTaxWithholdingCategoryList: builder.mutation({
      query: () => ({
        url: `/api/resource/Tax Withholding Category`,
        method: "GET",
      }),
    }),

    // end API for supplier master

    //start payment term master api
    postPaymentTerm: builder.mutation({

      query: ({ start = 0, limit = 12, filters = [], fields = [] }) => ({
        url: `/api/resource/Payment Term`,
        method: "GET",
        params: {
          filters: JSON.stringify(filters), // ✅ stringified filters array
          fields: JSON.stringify(
            fields.length > 0
              ? fields
              : [
                "payment_term_name",
                "mode_of_payment",
              ]
          ),
          order_by: "`tabPayment Term`.`modified` desc",
          limit_start: start,
          limit_page_length: limit,
        },
      }),

    }),
    totalPaymentTerm: builder.mutation({
      query: () => ({
        url: `/api/method/frappe.client.get_count?doctype=Payment Term`,
        method: "GET",
      }),
    }),

    totalModeOfPaymentList: builder.mutation({
      query: () => ({
        url: `/api/resource/Mode of Payment`,
        method: "GET",
      }),
    }),

    postCreatePaymentTerm: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Payment Term`,
        method: "post",
        body: data,
      }),
    }),

    postUpdatePaymentTerm: builder.mutation({
      query: ({ name, ...payload }) => ({
        url: `/api/resource/Payment Term/${name}`,
        method: "PUT",
        body: payload,
      }),
    }),

    // end API for payment term master
    //start payment term template master api
    postPaymentTermTemplate: builder.mutation({

      query: ({ start = 0, limit = 12, filters = [], fields = [] }) => ({
        url: `/api/resource/Payment Terms Template`,
        method: "GET",
        params: {
          filters: JSON.stringify(filters), // ✅ stringified filters array
          fields: JSON.stringify(
            fields.length > 0
              ? fields
              : [
                "template_name",
                "allocate_payment_based_on_payment_terms",
                "terms",
              ]
          ),
          order_by: "`tabPayment Terms Template`.`modified` desc",
          limit_start: start,
          limit_page_length: limit,
        },
      }),

    }),
    totalPaymentTermTemplate: builder.mutation({
      query: () => ({
        url: `/api/method/frappe.client.get_count?doctype=Payment Terms Template`,
        method: "GET",
      }),
    }),

    PaymentTermDetailsList: builder.mutation({
      query: (name) => ({
        url: `/api/resource/Payment Term/${encodeURIComponent(name)}`, // Encode for spaces/special chars
        method: "GET",
      }),
    }),

    PaymentTermList: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Payment Term`,
        method: "GET"
      }),
      // query: (filters) => ({
      //   url: `/api/resource/Payment Term`,
      //   params: {
      //     filters,
      //     fields: '["payment_term_name","name","description","invoice_portion","credit_days","due_date_based_on"]',
      //   },
      // }),
    }),

    postCreatePaymentTermTemplate: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Payment Terms Template`,
        method: "post",
        body: data,
      }),
    }),

    postUpdatePaymentTermTemplate: builder.mutation({
      query: ({ template_name, ...payload }) => ({
        url: `/api/resource/Payment Terms Template/${template_name}`,
        method: "PUT",
        body: payload,
      }),
    }),

    // end API for payment term template master
    // all detail info api
    // getItemDetailsData: builder.mutation({
    //   query: ({ doctype, name }) => ({
    //     url: `/api/method/frappe.client.get`,
    //     method: "POST",
    //     body: new URLSearchParams({
    //       doctype,
    //       name,
    //     }).toString(),
    //     headers: {
    //       "Content-Type": "application/x-www-form-urlencoded",
    //     },
    //   }),
    // }),
    getItemDetailsData: builder.mutation({
      query: ({ doctype, name }) => ({
        url: "/api/method/frappe.desk.form.load.getdoc",
        method: "GET",
        params: {
          doctype,
          name,
        },
      }),
    }),
    itemCodeLists: builder.mutation({
      query: () => ({
        url: `/api/resource/Item`,
        method: "GET",
        params: {
          filters: JSON.stringify([]),
          fields: JSON.stringify(["item_code"]),
          order_by: "`tabItem`.`modified` desc",
          limit_start: 0,
          limit_page_length: 0,
        },
      }),
    }),
  itemGroupFiltered: builder.query({
  query: () => {
    const filters = encodeURIComponent(JSON.stringify({ is_group: 1 }));
    return {
      url: `/api/resource/Item Group?filters=${filters}`,
      method: "GET",
    };
  },
}),



    // end
  }),
});

export const {
  useItemGroupFilteredQuery,
  useItemCodeListsMutation,
  usePostItemOrderMutation,
  useGetDoctypeDetailsQuery,
  useTotalItemMutation,
  useItemGroupMutation,
  useItemCompanyMutation,
  useItemBrandMutation,
  useItemUOMMutation,
  useItemGSTHSNCodeMutation,
  useItemTaxTemplateMutation,
  useItemTaxCategoryMutation,
  useItemQualityInspectionTemplateMutation,
  useItemWarehouseCheckInListMutation,
  useItemWarehouseRequestListMutation,
  useItemSupplierMutation,
  useItemSupplierSearchByNameMutation,
  useCountryListMutation,
  useCustomsTariffNumberMutation,
  useCustomerDetailsMutation,
  useCustomerGroupDetailsMutation,
  usePostCreateItemMutation,
  usePostUpdateItemMutation,
  usePostItemGroupOrderMutation,
  useTotalItemGroupMutation,
  usePriceDetailsListMutation,
  usePostCreateItemGroupMutation,
  usePostUpdateItemGroupMutation,
  usePostUOMOrderMutation,
  useTotalUOMMutation,
  usePostCreateUOMMutation,
  usePostUpdateUOMMutation,
  useGetUOMSearchMutation,
  usePostItemAttributeOrderMutation,
  useTotalItemAttributeMutation,
  usePostCreateItemAttributeMutation,
  usePostUpdateItemAttributeMutation,
  usePostItemPriceOrderMutation,
  useTotalItemPriceMutation,
  usePostCreateItemPriceMutation,
  usePostUpdateItemPriceMutation,
  useTotalItemListMutation,
  useTotalBatchNoListMutation,
  useGetItemDetailsMutation,
  usePostSupplierListMutation,
  useTotalSupplierCountMutation,
  usePostCreateSupplierMutation,
  usePostUpdateSupplierMutation,
  useTotalSupplierGroupListMutation,
  useTotalTerritoryListMutation,
  useTotalCurrencyListMutation,
  useTotalBankAccountListMutation,
  useTotalTaxWithholdingCategoryListMutation,
  useGetItemDetailsDataMutation,
  usePostPaymentTermMutation,
  useTotalPaymentTermMutation,
  useTotalModeOfPaymentListMutation,
  usePostCreatePaymentTermMutation,
  usePostUpdatePaymentTermMutation,
  usePostPaymentTermTemplateMutation,
  useTotalPaymentTermTemplateMutation,
  usePaymentTermListMutation,
  usePaymentTermDetailsListMutation,
  usePostCreatePaymentTermTemplateMutation,
  usePostUpdatePaymentTermTemplateMutation } = itemApi;
